import React from 'react';
import TemplateEditor from './TemplateEditor/templateEditor';
import styles from './menuTemplate.module.scss';

interface IProps {
    activeTemplate: null | string;
    onUpdateTemplateWithJson: (templateJson: string) => void;
    updateLoading: boolean;
};

const MenuTemplates: React.FC<IProps> = ({
    activeTemplate,
    onUpdateTemplateWithJson,
    updateLoading
}) => {

    return (
        <div className={styles.container}>
                <TemplateEditor
                    currentTemplate={String(activeTemplate)}
                    onSaveTemplate={onUpdateTemplateWithJson}
                    updateLoading={updateLoading}
                />
        </div>
    );
}

export default MenuTemplates;
